// Vendors
import $ from 'jquery';
import { debounce } from 'lodash';

/* Google Publisher Tag setup */
window.googletag = window.googletag || { cmd: [] };
const gptAdSlots = [];
const takenAdSlots = [];
const viewportSizes = {
  // used in resizeHandler below.
  width: {
    before: window.innerWidth
  }
};
const checkIfWeNeedToRerenderAds = () => {
  const newViewportWidth = window.innerWidth;

  if (
    (viewportSizes.width.before > 768 && newViewportWidth < 768) ||
    (viewportSizes.width.before > 728 && newViewportWidth < 728) ||
    (viewportSizes.width.before > 480 && newViewportWidth < 480) ||
    (viewportSizes.width.before > 336 && newViewportWidth < 336) ||
    (viewportSizes.width.before > 320 && newViewportWidth < 320) ||
    (viewportSizes.width.before > 300 && newViewportWidth < 300) ||
    (viewportSizes.width.before > 180 && newViewportWidth < 180) ||
    (viewportSizes.width.before < 768 && newViewportWidth > 768) ||
    (viewportSizes.width.before < 728 && newViewportWidth > 728) ||
    (viewportSizes.width.before < 480 && newViewportWidth > 480) ||
    (viewportSizes.width.before < 336 && newViewportWidth > 336) ||
    (viewportSizes.width.before < 320 && newViewportWidth > 320) ||
    (viewportSizes.width.before < 300 && newViewportWidth > 300) ||
    (viewportSizes.width.before < 180 && newViewportWidth > 180)
  ) {
    return true;
  }

  return false;
};

window.initializeAds = () => {
  const renderAd = (type, index) => {
    const adSlotID = index
      ? `gpt-ad-slot-${type}-${index}`
      : `gpt-ad-slot-${type}`;
    const $adContainer = $(`#${adSlotID}`);

    if (!$adContainer.length) return;

    takenAdSlots.push(adSlotID);
    if (!takenAdSlots[adSlotID]) {
      window.googletag.cmd.push(() => window.googletag.display(adSlotID));
    }
  };

  googletag.cmd.push(() => {
    // Set up Ad dimension sizes for dynamic sizes.
    const adSizes = {
      banner: googletag
        .sizeMapping()
        .addSize(
          [970, 0],
          [
            [970, 250],
            [970, 90],
            [768, 200],
            [728, 90]
          ]
        )
        .addSize(
          [768, 0],
          [
            [768, 200],
            [728, 90]
          ]
        )
        .addSize([320, 0], [[320, 50]])
        .build(),
      sidebar: googletag
        .sizeMapping()
        .addSize(
          [970, 0],
          [
            [970, 250],
            [970, 90],
            [728, 90],
            [480, 320],
            [480, 320],
            [336, 280],
            [320, 50],
            [300, 1050],
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [728, 0],
          [
            [728, 90],
            [480, 320],
            [480, 320],
            [336, 280],
            [320, 50],
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [480, 0],
          [
            [480, 320],
            [336, 280],
            [320, 50],
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [336, 0],
          [
            [336, 280],
            [320, 50],
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [320, 0],
          [
            [320, 480],
            [320, 50],
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [300, 0],
          [
            [300, 600],
            [300, 250],
            [216, 36],
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .addSize(
          [0, 0],
          [
            [180, 150],
            [168, 28],
            [160, 600],
            [120, 60],
            [120, 20]
          ]
        )
        .build()
    };

    // Generate and add 'banner, header, footer' ad types to gptAdSlots[].
    ['Banner', 'Header', 'Footer'].map((type, index) => {
      const typeLowerCase = type.toLowerCase();

      gptAdSlots[index] = googletag
        .defineSlot(
          `/3861510/${type}`,
          [
            [970, 250],
            [970, 90],
            [768, 200],
            [728, 90],
            [320, 50]
          ],
          `gpt-ad-slot-${typeLowerCase}`
        )
        .defineSizeMapping(adSizes.banner)
        .setCollapseEmptyDiv(true, true)
        .addService(googletag.pubads());
    });

    // ..and add the 9 'square' ads to gptAdSlots[].
    [...Array(10).keys()].map((value, index) => {
      const val = value + 3; // 3 through 12
      const movedIndex = index + 1; // 1 through 10

      gptAdSlots[val] = googletag
        .defineSlot(
          `/3861510/Square${movedIndex}`,
          [300, 250],
          `gpt-ad-slot-square-${movedIndex}`
        )
        .defineSizeMapping(adSizes.sidebar)
        .setCollapseEmptyDiv(true)
        .addService(googletag.pubads());
    });

    googletag.enableServices();
  });

  // Random sizes (mainly for testing).
  gptAdSlots[13] = googletag
    .defineSlot(`/3861510/flex-ad-1`, [728, 90], `gpt-ad-slot-flex-ad-1`)
    .setCollapseEmptyDiv(true, true)
    .addService(googletag.pubads());

  gptAdSlots[14] = googletag
    .defineSlot(`/3861510/HalfPage1`, [300, 600], `gpt-ad-slot-halfpage1`)
    .setCollapseEmptyDiv(true, true)
    .addService(googletag.pubads());

  // Vertical Space 1 through 3
  [15, 16, 17, 18].map((value, index) => {
    gptAdSlots[value] = googletag
      .defineSlot(
        `/3861510/VerticalSpace${index + 1}`,
        [
          [160, 600],
          [300, 250],
          [300, 1050]
        ],
        `gpt-ad-slot-VerticalSpace${index + 1}-1`
      )
      .setCollapseEmptyDiv(true, true)
      .addService(googletag.pubads());
  });

  // Render ads.
  const adTypes = {
    special: [
      'header',
      'footer',
      'banner',
      'halfpage1',
      'flex-ad-1',
      'VerticalSpace1-1',
      'VerticalSpace2-1',
      'VerticalSpace3-1',
      'VerticalSpace4-1'
    ],
    normal: ['square']
  };

  adTypes.special.map((type) => renderAd(type));
  adTypes.normal.map((type) =>
    [...Array(10).keys()].map((index) => renderAd(type, index + 1))
  );

  // Add options and finalize render process.
  googletag.pubads().enableSingleRequest();
  googletag.pubads().enableAsyncRendering();
  googletag.enableServices();

  // Resize event listener.
  window.addEventListener(
    'resize',
    debounce(() => {
      if (checkIfWeNeedToRerenderAds()) {
        browserResize();
        viewportSizes.width.before = window.innerWidth;
      }
    }, 200)
  );

  // If they want to 'refresh' ads dynamically, see https://developers.google.com/publisher-tag/guides/control-ad-loading#best_practices
};

// Resize event handler.
function browserResize() {
  googletag.cmd.push(() => googletag.pubads().refresh());
}

let delay = 10;
let initAdsHere = true;
if ($('#taxonomy-list-app').length || $('#events-app').length) {
  initAdsHere = false;
}

if (initAdsHere) {
  let initializeGPT = setInterval(() => {
    if (window.googletag && googletag.apiReady) {
      window.initializeAds();
      clearInterval(initializeGPT);
    }
  }, delay);
}
